const frontendURL = '/cat/inspection/';
const backendURL = '/api/references/refinspection/';
const name = 'Організація (інспекція)';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
